export default "__VITE_ASSET__c776c945__"